import { Brand } from '@/models/Brand';
import { Component, Prop } from 'vue-property-decorator';
import AbstractFilterMultipleModel from '@/components/CustomFilter/AbstractFilterMultipleModel';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';

@Component<BrandFilter>({})
export default class BrandFilter extends AbstractFilterMultipleModel implements FilterInterface {

  // #region @Props

  @Prop({ default: 'brand' })
  protected filterStorageKey!: string;

  @Prop({ default: 'purchase_order_filters' })
  protected filtersStorageKey!: string;

  @Prop({
    default: () => new Brand()
      .limit(100)
      .sort('name', 'ASC')
  })
  protected model!: Brand;

  @Prop({ default: 'Merken' })
  protected namePlural!: string;

  @Prop({ default: 'Zoek naar Merk' })
  protected placeholderSearch!: string;

  // #endregion
}
